<div class="graph-container">
  @if (graph()) {
  <div class="title">{{title()}}</div>
  <p-chart [type]="graph().type" [data]="graph().data" [options]="graph().options" height="23rem"
    [responsive]="true"></p-chart>
  }
</div>